import React from "react";

import "./ConfirmationCard.css";
import Like from "../images/Like.png";
import Dislike from "../images/Dislike.png";

export default class extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            actions: props.actions
        }
    }

    handleClick(act) {
        this.props.activity.text = "Confirmation|resp";
        this.props.store.dispatch({
            type: 'WEB_CHAT/SEND_MESSAGE',
            payload: { text: act.value, value:"resposta|confirmation" }
        });
    }

    render() {

        return (
            <div className="defaultcard_suggestions buttonsLikeDislike">
                <button className="like" onClick={() => { this.handleClick(this.state.actions[0]) }}><img alt="+1" height="20" width="20" src={Like}></img></button>
                <button onClick={() => { this.handleClick(this.state.actions[1]) }}><img alt="-1" height="20" width="20" src={Dislike}></img></button>
            </div>
        );
    }
};